import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '@shared/modals/loading/loading.service';

@Injectable()
export class ProgressHttpInterceptor implements HttpInterceptor {
  // This Array should only contain in-progress http requests
  private requests: HttpRequest<any>[] = [];

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


       this.requests.push(request);
    this.loadingService.setLoader(true);

    return next.handle(request)
      .pipe(
        finalize(() => {
          this.removeRequest(request);
        })
      );
  }

  private removeRequest(request: HttpRequest<any>) {
    this.requests.splice(this.requests.indexOf(request), 1);
    this.loadingService.setLoader(this.requests.length > 0);
  }
}
